import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { UntypedFormBuilder, FormGroup, NgForm, Validators } from '@angular/forms';
import { Router, RouterModule } from '@angular/router';
import { RequestService } from '../services/request.service';
import { TranslateModule } from '@ngx-translate/core';
import { Translate } from '../services/translate.service';

@Component({
  selector: 'app-login',
  standalone: true,
  imports: [CommonModule, FormsModule, ReactiveFormsModule, RouterModule, TranslateModule],
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss']
})
export class LoginComponent implements OnInit {
  form: any;
  loginType = 'store';
  errorMsg = '';
  isError = false;
  constructor(
    public fb: UntypedFormBuilder,
    private request: RequestService,
    private router: Router,
    private translate: Translate
  ) {
    this.form = this.fb.group({
      store_id: ['', Validators.required],
      user_id: ['', Validators.required],
      password: ['', Validators.required]
    });
  }

  async ngOnInit() {
    // 翻訳初期化
    await this.translate.init();
    console.log('✅ ログインページ - 翻訳初期化完了');
  }
  submit() {
    // login type
    this.form.value.type = this.loginType;
    this.form.value.admin = true;
    if (this.loginType === 'manager') {
      this.form.value.store_id = 55000;
    }
    this.request.post('api/auth/login', this.form.value).then(res => {
      console.log('🔐 Login response:', res);
      if (res && res.status) {
        // Store authentication data
        localStorage.setItem('dashboardActive', res.result.active || '1');
        localStorage.setItem('userRole', res.result.roles ? res.result.roles[0] : 'admin');
        localStorage.setItem('accessToken', res.result.access_token || '');
        localStorage.setItem('userId', res.result.user?.id || '');

        console.log('✅ Auth data stored:', {
          dashboardActive: localStorage.getItem('dashboardActive'),
          userRole: localStorage.getItem('userRole'),
          hasToken: !!localStorage.getItem('accessToken'),
          userId: localStorage.getItem('userId')
        });

        // Navigate to admin/auth/member page
        console.log('🚀 Navigating to /admin/auth/member');
        this.router.navigate(['/admin/auth/member'], { queryParams: { admin: true } });
      } else {
        this.isError = true;
        this.errorMsg = res?.result?.error || '認証に失敗しました';
      }
    }).catch(error => {
      this.isError = true;
      this.errorMsg = 'ログインエラーが発生しました';
      console.error('❌ Login error:', error);
    });
  }

  changeLoginType(type: any) {
    if (this.isError) {
      this.isError = false;
    }
    this.loginType = type;
    if (this.loginType === 'store') {
      this.form = this.fb.group({
        store_id: ['', Validators.required],
        user_id: ['', Validators.required],
        password: ['', Validators.required]
      });
    }
    if (this.loginType === 'manager') {
      this.form = this.fb.group({
        password: ['', Validators.required],
        email: ['', Validators.required]
      });
    }
  }
  loginInfoChange() {
    if (this.isError) {
      this.isError = false;
    }
  }
}
